module.exports = __webpack_public_path__ + "static/video-stab-558d78ad77912d4c3ebb94c4f724d196.png";